// extracted by mini-css-extract-plugin
export default {"root":"SignStatus_root__0mbmP","Idle":"SignStatus_Idle__a+P7G","Done":"SignStatus_Done__yLY8x","Timeout":"SignStatus_Timeout__PFnAH"};